<template>
  <div class="nom-input" style="margin-top: 8px">

    <div class="nom-input-title">
      <span @click="sum" class="sum-icon" style="margin-right: 6px">&sum;</span>
      <strong style="color: black">{{ nomenclature.name }}</strong>
      <i style="cursor: pointer; margin-left: 8px; color: #000" class="fa fa-edit" @click="openModal"/>
    </div>

    <div class="nomenclature-container" v-if="!lock">
      <div v-if="nomenclature.selectValues">
        <div v-for="[key, input] in Object.entries(nomenclature.selectValues)" :key="input.id + key">
          <span>{{ input.name }}   <i @click="removeDoc(key)" class="el-icon-close" style="cursor: pointer; font-weight: bold; font-size: 14px"></i></span>

          <div style="margin-top: 4px; display: flex; flex-wrap: wrap">
            <div class="tag" v-for="(value, k) in input.values" :key="value.id + k" @click="removeValue(key, k)">
              {{ value.label }}
              <i class="multiselect__tag-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      @close="close"
      append-to-body :title="selectDoc ? selectDoc.name : `Разделы документации`" :visible.sync="dialogObject">
      <div class="add-jobs" v-if="!selectDoc">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">
          <div
            @click="saveDoc(list)"
            class="jobs-li" v-for="(list, index) in filteredList" :key="index"
          >
            <span>{{ list.name }}</span>
          </div>
        </div>
      </div>
      <div v-else-if="!openDialogMaterials">
        <filter-select
          v-if="dialogObject"
          noTag
          @blur="blur"
          :isLoading="nomenclature.isLoading"
          @search="(s) => searchL(s)"
          @addNew="(name) => addNew(nomenclature, name)"
          :addNewEnable="nomenclature.isEditable"
          multiple
          hide-label
          @remove="(e) => removeMaterial(e)"
          @select="(e) => inputMaterial(e, nomenclature)"
          v-model="nomenclatureLocal"
          :label="nomenclature.name"
          :options="filterOptions">x
        </filter-select>
        <div class="create-footer">
          <el-button @click="close">Отменить</el-button>
          <el-button type="primary" @click="save">Сохранить</el-button>
        </div>
      </div>
    </el-dialog>

    <div>
      <AddNewOption @new-option="newOption" :zoneId="selectDoc && selectDoc.id" @close="" ref="addNewOption" :notActive="nomenclature.notActive"/>
      <el-dialog
        append-to-body
        :show-close="false"
        :title="selectMaterial.label"
        :visible.sync="openDialogMaterials"
        width="30%"
        center
      >
        <div v-if="selectMaterial && selectMaterial.details">
          <template v-if="currentType !== 'multiple'">
            <el-input
              :controls="false"
              style="margin-top: 4px"
              type="number"
              @input="inputMat(selectMaterial)"
              placeholder="Значение"
              v-model="selectMaterial.fact"
              class="input-with-select">
              <template slot="append">{{ selectMaterial.details[1] && selectMaterial.details[1].label }}</template>
            </el-input>
            <div style="display: flex; align-items: center; margin-top: 8px">
              <span v-if="!selectMaterial.withoutPlan">План: <strong>{{
                  selectMaterial.details[2] || 0
                }}</strong></span>
            </div>


            <template v-if="currentType === 'constructions'">
              <el-input
                :controls="false"
                style="margin-top: 22px"
                type="number"
                placeholder="Значение"
                v-model="selectMaterial.factUnit"
                class="input-with-select">
                <template slot="append">{{ selectMaterial.details[3] && selectMaterial.details[3].label }}</template>
              </el-input>
              <div style="display: flex; align-items: center; margin-top: 8px" v-if="!selectMaterial.withoutPlan">
                <span>План на ед: <strong>{{ selectMaterial.details[4] || 0 }}</strong></span>
              </div>
            </template>
          </template>

          <div v-if="selectMaterial.isDetail" style="margin-top: 22px">
            <el-input v-model="selectMaterial.detail" placeholder="Примечание"></el-input>
          </div>

          <div style="display: flex; align-items: center; margin-top: 12px"
               v-if="!selectMaterial.withoutPlan && currentType !== 'multiple'">
            <el-checkbox
              v-model="selectMaterial.inVolume"
              label="в объем"
            ></el-checkbox>
          </div>
        </div>

        <div style="margin-top: 32px; display: flex; justify-content: flex-end">
          <el-button @click="closeMaterial">Закрыть</el-button>
          <el-button type="primary" @click="saveMaterial(true)">Сохранить</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import _, {debounce, orderBy} from "lodash";
import {getChildList} from "../../../../utils/getChild";
import FilterSelect from "../../../../components/FilterSelect";
import AddNewOption from "./AddNewOption";
import {BigNumber} from "bignumber.js";
import {v4 as uuidv4} from "uuid";
import CyrillicToTranslit from "cyrillic-to-translit-js";

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


export default {
  components: {AddNewOption, FilterSelect},
  props: ['nomenclature', 'selectValuesProp', 'options_works', 'dirs', 'job'],
  data() {
    return {
      options: [],
      optionsSaved: [],
      firstSave: [],
      dialogObject: false,
      nomenclatureLocal: [],
      search: '',
      selectDoc: null,
      lock: false,
      list: [],
      selectMaterial: {},
      openDialogMaterials: false
    };
  },
  name: "NomenclatureInput",
  watch: {
    handler() {
      this.selectMaterial = {...this.selectValuesProp}
    },
    deep: true
  },
  async mounted() {
    let result = []
    this.fire()
      .collection('documentation')
      .get()
      .then((data) => {
        data.forEach((subDoc) => {
          const data = subDoc.data();

          result.push({
            id: subDoc.id,
            name: data.name,
            objects: data.objects,
            index: data.index,
            parentId: data.parentId || undefined,
            isParent: data.isParent,
          });
        });
      }).finally(() => {
      this.list = _.orderBy(getChildList(result), 'index', ['asc']).map((d) => {
        return {
          ...d,
          isParent: d.isParent || null,
          objects: d.objects || null,
          parentId: d.parentId || null,
        }

      });
      this.loader = false;
    }).catch(() => {
      this.loader = false;
    });

   this.newOption()
  },
  methods: {
    async newOption() {
      const resp = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .doc(this.nomenclature.id)
        .collection('optionsList').orderBy('index', 'asc').limit(100).get()


      const optionsList = []
      resp.forEach((d) => {
        optionsList.push({
          ...d.data(),
          isCreate: true,
        })
      })


      this.options = [...optionsList]
      this.optionsSaved = JSON.parse(JSON.stringify([...optionsList]))
      this.firstSave = JSON.parse(JSON.stringify([...optionsList]))

    },
    openModal() {
      this.optionsSaved = JSON.parse(JSON.stringify([...this.firstSave]))

      this.dialogObject = true
      this.search = ''
      this.options = JSON.parse(JSON.stringify(this.firstSave))

      try {

        const work = this.options_works.find(({id}) => id === this.job.job.work_type)

        if (work && work.dir) {
          const dir = this.dirs.find(({id}) => id === work.dir);

          if (dir && dir.usePermissionDocs) {
            this.list = this.list.filter((d) => dir.available_docs.includes(d.id) || !d.id)
          }

          if (dir && dir.defaultDocs) {
            const defaultDoc = this.list.find(({id}) => id === dir.defaultDocs)
            if (defaultDoc) {
              this.saveDoc(defaultDoc)
            }
          }

        }
      } catch (e) {
        console.error(e)
      }

    },
    sum() {
      let result = 0;

      let id = Object.values(this.nomenclature.volumeId).findIndex((o) => o)



      Object.values(this.nomenclature.selectValues).forEach(({values}) => {
        Object.values(values || []).forEach((v) => {
          // try {
            console.log(v.inVolume, 'v')
            if (v.inVolume) {
              result += Number(this.currentType === 'constructions' ? v.factUnit : v.fact)
            } else if(v.details[id + 1]) {
              result += Number(v.details[id + 1])
            }
          // } catch (e) {}
        })
      })
      console.log(result, 'result')

      this.$emit('toFact', result || 0)
    },
    searchL: debounce(async function (search) {
      if (this.openDialogMaterials) {
        this.nomenclature.isLoading = false
        return
      }

      this.nomenclature.isLoading = true
      this.nomenclature = {...this.nomenclature}

      console.log(this.selectDoc, 'this.selectDoc')

      let resp = null
      if (search && search.length) {
        const cyrillicToTranslit = new CyrillicToTranslit();

        const txt = String(cyrillicToTranslit.transform(search).toLowerCase())
        const txtArray = txt.split(' ')


        resp = await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(this.nomenclature.id)
          .collection('optionsList')
          // .where('searchName', 'array-contains', txtArray[txtArray.length -1])
          .where('customFilters', 'customFilters', JSON.stringify({
            label: {$regex: escapeRegExp(search.toLowerCase()), $options: 'i'}
          }))

          .where('zoneId', '==', this.selectDoc.id)
          .limit(100).get()
      } else {
        resp = await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(this.nomenclature.id)
          .collection('optionsList')
          .orderBy('index', 'asc')
          .where('zoneId', '==', this.selectDoc.id)
          .limit(100).get()
      }

      const optionsList = []
      resp.forEach((d) => {
        optionsList.push({
          ...d.data(),
          isCreate: true,
        })
      })

      if (!this.openDialogMaterials) {
        this.options = [...orderBy(optionsList, 'index', 'asc')]
      }

      this.nomenclature.isLoading = false

      this.nomenclature = {...this.nomenclature}
    }, 500),
    removeDoc(key) {
      this.lock = true
      const nomenclature = {...this.nomenclature.selectValues}

      delete nomenclature[key]


      this.$emit('save', {
        ...nomenclature
      })

      setTimeout(() => {  this.lock = false},50)
    },
    removeValue(key, k) {
      this.lock = true
      const nomenclature = {...this.nomenclature.selectValues}

      nomenclature[key].values.splice(k, 1)

      if(!nomenclature[key].values.length) {
        delete nomenclature[key]
      }

      this.$emit('save', {
        ...nomenclature
      })

      setTimeout(() => {  this.lock = false},50)

    },
    saveMaterial(flag) {

      const saveOptions = JSON.parse(JSON.stringify(this.optionsSaved))
      let childIndex = saveOptions.findLastIndex(
        ({
           uid,
           value,
           label
         }) => uid === this.selectMaterial.uid
          && this.selectMaterial.value.trim() === value.trim()
          && this.selectMaterial.label.trim() === label.trim()
      );

      if(childIndex === -1) {
        const index = this.options.findLastIndex(
          ({
             uid,
             value,
             label
           }) => uid === this.selectMaterial.uid
            && this.selectMaterial.value.trim() === value.trim()
            && this.selectMaterial.label.trim() === label.trim()
        );


        childIndex = saveOptions.length

        this.options = [...saveOptions, this.options[index]]
      } else {
        this.options = [...saveOptions]

      }

      const originalLabel = String(this.selectMaterial.label)

      if (this.selectMaterial.isDetail && this.options[childIndex]) {
        const input = JSON.parse(JSON.stringify(this.options[childIndex]))
        const option = {
          ...JSON.parse(JSON.stringify(this.options[childIndex])),
          value: JSON.parse(JSON.stringify(this.options[childIndex])).value,
          label: input.originalLabel || input.label,
        }

        this.options.push({...option})
      }


      if ((this.currentType === 'multiple' || flag) && this.options[childIndex]) {
        this.options[childIndex].label = '' + this.selectMaterial.value + (this.selectMaterial.fact && ' - ' + this.selectMaterial.fact) + ' ' + ((this.selectMaterial.details[1] && this.selectMaterial.details[1].label) || '')
      }

      if (this.currentType === 'materials') {
        this.options[childIndex].originalLabel = '' + this.options[childIndex].value
      }

      if (this.currentType === 'multiple') {
        try {

          const trueKeys = Object.keys(this.nomenclature.volumeId).filter(key => this.nomenclature.volumeId[key] === true);

          const details = this.options[childIndex].details
          if (trueKeys && trueKeys.length) {
            let sumKey = 0;
            let label = ''

            trueKeys.forEach((key) => {
              if (details[key] && !isNaN(details[key])) {
                sumKey += Number(details[key])
                label = this.nomenclature.labels[key]
              }
            })

            this.options[childIndex].originalLabel = '' + this.options[childIndex].value
            this.options[childIndex].label = '' + this.selectMaterial.value + ' - (' + sumKey + ' ' + label + ')'
          } else if (!flag) {
            return;
          }
        } catch (e) {
          console.error(e)
          if (!flag) {
            return
          }
        }
      }

      this.options[childIndex].value = JSON.parse(JSON.stringify(this.options[childIndex].label))
      this.options[childIndex].fact = this.selectMaterial.fact;
      this.inVolume = this.selectMaterial.inVolume;


      const valueIndex = this.nomenclatureLocal.findLastIndex(({uid}) => uid === this.selectMaterial.uid);

      this.nomenclatureLocal[valueIndex].label = this.options[childIndex].label
      this.nomenclatureLocal[valueIndex].fact = this.selectMaterial.fact;
      if (this.selectMaterial.isDetail) {
        this.nomenclatureLocal[valueIndex].detail = this.selectMaterial.detail
      }


      if (this.selectMaterial.inVolume && !this.selectMaterial.withoutPlan) {
        this.options[childIndex].label = '• ' + this.options[childIndex].label;
        this.nomenclatureLocal[valueIndex].inVolume = true
      }

      if (this.currentType === 'constructions') {
        this.nomenclatureLocal[valueIndex].factUnit = this.selectMaterial.factUnit;
        this.options[childIndex].label += isNaN(this.selectMaterial.factUnit) ? '' : ` (${this.selectMaterial.factUnit} ${(this.selectMaterial.details[3] && this.selectMaterial.details[3].label)})`
      }

      if (this.selectMaterial.isDetail && this.selectMaterial.detail) {
        this.options[childIndex].label += ' (' + this.selectMaterial.detail + ')'
      }


      this.nomenclatureLocal[valueIndex].label = JSON.parse(JSON.stringify(this.options[childIndex].label))
      this.nomenclatureLocal[valueIndex].value = JSON.parse(JSON.stringify(this.options[childIndex].label))
      this.options[childIndex].value = JSON.parse(JSON.stringify(this.options[childIndex].label))

      this.options[childIndex].originalLabel = originalLabel

      this.openDialogMaterials = false;
      this.optionsSaved = JSON.parse(JSON.stringify(this.options))

      this.selectMaterial = {}
    },
    removeMaterial(e, input) {
      const index = this.options.findIndex(({uid, value, label}) => uid === e.uid && value.trim() === e.value.trim())

      if (this.options[index] && this.options[index].originalLabel) {
        this.options[index].label = '' + this.options[index].originalLabel;
        this.options[index].value = '' + this.options[index].originalLabel;
      }

      if (index !== -1 && this.options.filter((o) => o.uid === e.uid).length > 1) {
        this.options.splice(index, 1)
      }

      this.options = [...this.options]
      this.optionsSaved = JSON.parse(JSON.stringify([...this.options]))

    },
    closeMaterial() {
      this.openDialogMaterials = false;
      this.nomenclatureLocal = this.nomenclatureLocal.filter(({
                                                                uid,
                                                                value
                                                              }) => uid !== this.selectMaterial.uid || value !== this.selectMaterial.value)
      setTimeout(() => {
        this.selectMaterial = {}
      }, 200)
    },
    inputMat(selectMaterial) {
      if (selectMaterial.withoutPlan) {
        return
      }
      selectMaterial.factUnit = new BigNumber(selectMaterial.fact || 0).multipliedBy(selectMaterial.details[4] || 0).toNumber()
    },
    addNew(data, name) {
      this.input = data;
      let zone = null
      try {
        zone = this.form.job.inputs.find(({id}) => id === 'zone').value || null
      } catch (e) {
      }

      this.$refs.addNewOption.open({
        zone,
        data, name
      })
    },
    save() {
      const nomenclature = {...this.nomenclature}

      if (!nomenclature.selectValues) {
        nomenclature.selectValues = {}
      }

      const uid = uuidv4()

      if (!nomenclature.selectValues[uid + '_' + this.selectDoc.id]) {
        nomenclature.selectValues[uid + '_' + this.selectDoc.id] = {
          ...this.selectDoc,
          values: []
        }
      }
      nomenclature.selectValues[uid + '_' + this.selectDoc.id].values = this.nomenclatureLocal

      this.$emit('save', {
        ...nomenclature.selectValues
      })

      this.close()
    },
    closeBtn() {
      if(this.selectDoc) {
        return this.selectDoc = null
      }
      this.close()
    },
    close() {
      this.options = JSON.parse(JSON.stringify([...this.optionsSaved]))
      this.openDialogMaterials = false;
      this.dialogObject = false
      this.nomenclatureLocal = []
      this.selectDoc = null
      this.nomenclature.isLoading = false
    },
    fire() {
      // if (this.$route.query.version) {
      //   return myFirestore
      //     .collection('projects')
      //     .doc(this.$store.state.project.id)
      //     .collection('versions')
      //     .doc(this.$route.query.version)
      // }
      //
      // if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
      //   return myFirestore
      //     .collection('projects')
      //     .doc(this.$store.state.project.id)
      //     .collection('plan')
      //     .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      // }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    saveDoc(d) {
      this.selectDoc = d
      this.searchL()
    },
    inputMaterial(e, input) {
      this.selectMaterial = {
        ...e,
        fact: '',
        factUnit: '',
        detail: '',
        withoutPlan: input.withoutPlan,
        isDetail: input.isDetail,
        inVolume: this.currentType === 'constructions',
        parentId: input.id,
        type: input.type
      };

      if (this.currentType !== 'multiple' || input.isDetail) {
        this.openDialogMaterials = true
      }

      if (this.currentType === 'multiple' && !input.isDetail) {
        this.saveMaterial()
      }
    },
  },
  computed: {
    filterOptions() {
      return _.orderBy(this.options.filter(({zoneId}) => zoneId === this.selectDoc.id), 'index', 'asc')
    },
    currentType() {
      let type = 'multiple'

      if(this.nomenclature.notActive[1] && this.nomenclature.notActive[2]) {
        type = 'constructions'
      } else if(this.nomenclature.notActive[1] || this.nomenclature.notActive[2]) {
        type = 'materials'
      }

      return type
    },
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  }
}
</script>

<style scoped lang="scss">
.nom-input {

}

.nom-input-title {
  display: flex;
  align-items: center;
}

.sum-icon {
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #fff;
  background: black;
  cursor: pointer;
  border-radius: 50%;
}

.nomenclature-container {
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  padding: 8px 15px;
  min-height: 40px;
  box-sizing: border-box;
  margin-top: 8px;
}

.tag {
  position: relative;
  display: flex;
  padding: 4px 26px 4px 10px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #3a8ee6;
  margin-bottom: 5px;
  overflow: hidden;
  max-width: 100%;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.multiselect__tag-icon {
  background: #3a8ee6 !important;
  &:hover {
    &:after {
      color: #1c5591 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/NomenclatureInput.vue